// src/api/serviceCategories.ts
import api from "./client";

export type ServiceCategory = {
  service_category_id: string;
  name: string;
  sort_order: number;
  aliases: string[];
};

type SuggestCategoryAliasesPayload = {
  service_category_id?: string;
  name: string;
  aliases?: string[];
};

type CreateCategoryPayload = {
  name: string;
  sort_order?: number;
  aliases?: string[];
};

type UpdateCategoryPayload = {
  name?: string;
  sort_order?: number;
  aliases?: string[];
};

export const fetchServiceCategories = async (): Promise<ServiceCategory[]> => {
  try {
    const res = await api.get("/manageServiceCategories");
    return res.data || [];
  } catch (error) {
    console.error("❌ Failed to fetch service categories:", error);
    return [];
  }
};

export const createServiceCategory = async (
  payload: CreateCategoryPayload
): Promise<ServiceCategory> => {
  try {
    const res = await api.post("/manageServiceCategories", payload);
    return res.data;
  } catch (error) {
    console.error("❌ Failed to create service category:", error);
    throw error;
  }
};

export const suggestCategoryAliases = async (
  payload: SuggestCategoryAliasesPayload
): Promise<string[]> => {
  try {
    const res = await api.post("/suggestCategoryAliases", payload);
    return res.data?.suggestions || [];
  } catch (error) {
    console.error("❌ Failed to suggest category aliases:", error);
    throw error;
  }
};

export const updateServiceCategory = async (
  service_category_id: string,
  payload: UpdateCategoryPayload
): Promise<ServiceCategory> => {
  try {
    const body = { service_category_id, ...payload };
    const res = await api.put("/manageServiceCategories", body);
    return res.data;
  } catch (error) {
    console.error("❌ Failed to update service category:", error);
    throw error;
  }
};

export const deleteServiceCategory = async (
  service_category_id: string
): Promise<void> => {
  try {
    await api.delete("/manageServiceCategories", {
      data: { service_category_id },
    });
  } catch (error) {
    console.error("❌ Failed to delete service category:", error);
    throw error;
  }
};
